module.exports = __webpack_public_path__ + "static/jb-hi-fi-191849ae9a622a3e68057fa8b4a1a8eb.webp";